import React from 'react';
import clsx from 'clsx';
import RowElement from '../DataElements/RowElement'
import {NameTextField} from '../../../styling/Styles';

const RadioComponent = (props) => {

    const {
        deleteComponent,
        options,
        handleOptionLabel,
        lockDeleteOption,
        deleteOption,
        addOption
    } = props 

    const [displayContent, setDisplayContent] = React.useState(false); 


    return(
        <div className={clsx('spacingTopDiv')}>
            <RowElement
                label='Radio'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />
            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  

                <div className={clsx('spacingTopDiv','flexRowDirection')} > 
                    Options:
                    <span style={{marginLeft: '7.8vw'}} className ={clsx('flexProps2')} >
                        <span style={options.length > 5 ? {overflowY: 'scroll', maxHeight: '160px'} : null} >
                            {options.map( (option,index) =>                                     
                                <div id={`RadioComponent${index}`} className ={clsx('flexRowDirection')}>
                                    <NameTextField
                                        placeholder=' Radio option'
                                        onInput={e =>handleOptionLabel(e,index)}
                                        value={option}
                                        error={ lockDeleteOption === true }
                                        helperText={ lockDeleteOption === true ? 'There should be at least one radio option' : null}
                                    /> &nbsp;&nbsp;
                                    <i className={clsx('fas', 'fa-times-circle', 'teamSelector')}  style={{display: 'inline-block', paddingTop: '0.4vw'}}
                                        onClick ={() => deleteOption(index)}
                                        aria-hidden="true"
                                    />
                                </div>
                            )
                            }
                        </span>
                        <span onClick={ () => addOption()} style={{fontSize: '0.7vw'}} className={clsx('lightBlue','teamSelector')} aria-hidden="true"> Add new option</span>
                    </span>
                    
                    
                </div>
                
            </div>
            <hr className={clsx('blueLine','spacingTopDiv')}/> 
        </div>
    )

}

export default RadioComponent;